import { handleRequest } from '_services';
import { store } from '_helpers'
import { getQueue } from './actionQueue.service';

export const errorReportService = {
    send,
};

async function send(error = undefined, info = undefined, userMsg = undefined) {
    let state = JSON.stringify(store.getState());
    let actions = JSON.stringify(getQueue());
    let errorStr = undefined;
    if( error ) {
        errorStr = error.message + '\n' + error.stack;
    }
    info = info ? JSON.stringify(info) : undefined;
    userMsg = userMsg ? JSON.stringify(userMsg) : undefined;

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ error: errorStr, info, userMsg, state, actions })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/errorreport/send', requestOptions, true, true);
}

